import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { getAllProducts } from '../../services/api';
import { Product } from '../profile/profileSlice'; // Now correctly imports the Product type

interface CatalogState {
  products: Product[];
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
}

const initialState: CatalogState = {
  products: [],
  status: 'idle',
};

export const fetchCatalog = createAsyncThunk('catalog/fetchCatalog', async () => {
  const response = await getAllProducts();
  return response;
});

const catalogSlice = createSlice({
  name: 'catalog',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCatalog.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchCatalog.fulfilled, (state, action: PayloadAction<Product[]>) => {
        state.status = 'succeeded';
        state.products = action.payload;
      })
      .addCase(fetchCatalog.rejected, (state) => {
        state.status = 'failed';
      });
  },
});

export default catalogSlice.reducer;